import styled from "styled-components"

import { useNavigate } from 'react-router-dom';
import theme from "../../styles/theme";
import { useGetNaviInfo } from "../../interfaces/common";
import { useEffect, useState } from "react";

const MenuHeader = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    background: ${theme.color.white[100]};
    h2 {
        margin: 0;
        color: ${theme.color.black[80]};
        font-size: ${theme.fontSize.base};
        cursor: pointer;
    }

    h3 {
        margin: 0;
        color: ${theme.color.black[40]};
        font-size: ${theme.fontSize.base};
        font-weight: normal;
        cursor: pointer;
    }
`;

const NaviText = () => {

    const navigate = useNavigate();
    const {data} = useGetNaviInfo();

    const [target, setTarget] = useState();

    useEffect(()=>{
        setTarget(data);
    },[data])

    return (
        <MenuHeader>
                {target &&
                    target.map((item,index)=>{
                        return index < (target.length - 1) ? (<h3 key={index} onClick={()=>navigate(item.url)}>{item.text}&nbsp;&nbsp;/&nbsp;&nbsp;</h3>) : (<h2 key={index}>{item.text}</h2>)
                        
                    })
                }
        </MenuHeader>
    )
}

export default NaviText;
